import React from 'react';
import { motion } from 'framer-motion';
export function PricingCards() {
  return <section id="pricing" className="py-16 px-4 bg-brand-base border-t border-brand-gold/15 relative overflow-hidden" data-id="element-218">
      <div className="absolute inset-0 grain pointer-events-none" data-id="element-219"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-220">
        <h2 className="font-display text-3xl sm:text-5xl font-extrabold text-brand-gold mb-12 glow-gold tracking-tight" data-id="element-221">
          ELEGÍ TU PACK
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-222">
          {/* Basic */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="border border-brand-gold/40 rounded-3xl p-8 flex flex-col bg-brand-ink/70 backdrop-blur-sm relative items-center" style={{
          boxShadow: '0 24px 50px -20px rgba(0,0,0,0.6), inset 0 1px 0 rgba(212, 168, 67, 0.1)'
        }} data-id="element-223">
            <div className="mb-6" data-id="element-224">
              <h3 className="text-xl sm:text-2xl font-extrabold text-brand-cream mb-2 flex items-center justify-center gap-2" data-id="element-225">
                <span data-id="element-226">📦</span>
                <span data-id="element-227">MEGAPACK COCINA SIN GLUTEN Y SIN AZÚCAR™</span>
              </h3>
              <p className="font-bold text-brand-gold mb-4 glow-gold" data-id="element-228">
                6 Tomos + 6 Bonos
              </p>
              <p className="text-brand-cream/75 text-sm leading-relaxed" data-id="element-229">
                Ideal para la mujer que quiere volver a disfrutar el pan, los
                postres y la mesa familiar sin miedo a la glucosa — con un
                sistema completo listo para usar desde hoy.
              </p>
            </div>

            <div className="mb-8 mt-auto" data-id="element-230">
              <p className="text-brand-cream/40 line-through text-lg font-bold mb-1" data-id="element-231">
                $51.000
              </p>
              <div className="flex items-baseline gap-2 justify-center" data-id="element-232">
                <span className="text-brand-gold glow-gold text-lg" data-id="element-233">✦</span>
                <span className="font-display text-5xl font-extrabold text-brand-gold glow-gold" data-id="element-234">
                  $19.990
                </span>
                <span className="text-xl font-bold text-brand-gold/70" data-id="element-235">
                  ARS
                </span>
                <span className="text-brand-gold glow-gold text-lg" data-id="element-236">✦</span>
              </div>
            </div>

            <motion.a href="https://www.impulsodigitalstore.com/cart/42985551102029:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-brand-gold text-brand-base font-extrabold text-base sm:text-lg py-4 px-6 rounded-xl shadow-lg hover:shadow-[0_10px_40px_rgba(212,168,67,0.5)] transition-all text-center inline-block uppercase tracking-wide" data-id="element-237">
              ✦ QUIERO MI MEGAPACK AHORA ✦
            </motion.a>
          </motion.div>

          {/* Premium */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="border-2 border-brand-gold rounded-3xl p-8 flex flex-col relative md:-translate-y-4 items-center" style={{
          background: '#141414',
          boxShadow: '0 20px 50px -25px rgba(0, 0, 0, 0.6)'
        }} data-id="element-238">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-brand-gold text-brand-base px-6 py-1.5 rounded-full font-extrabold text-xs uppercase tracking-widest shadow-lg whitespace-nowrap glow-gold" data-id="element-239">
              ⭐ MÁS POPULAR
            </div>

            <div className="mb-6 mt-2" data-id="element-240">
              <h3 className="text-xl sm:text-2xl font-extrabold text-brand-gold mb-2 flex items-center justify-center gap-2" data-id="element-241">
                <span data-id="element-242">👑</span>
                <span data-id="element-243">MEGAPACK + MASTERCLASS PAN DE CAMPO Y MASA MADRE™</span>
              </h3>
              <p className="font-bold text-brand-cream mb-4" data-id="element-244">
                6 Tomos + 6 Bonos + Masterclass Técnica Elite
              </p>
              <p className="text-brand-cream/75 text-sm leading-relaxed" data-id="element-245">
                Ideal para quien quiere no solo cocinar sin culpa sino dominar
                las técnicas más avanzadas de la panadería saludable.
              </p>
            </div>

            <div className="mb-8 mt-auto" data-id="element-246">
              <p className="text-brand-cream/40 line-through text-lg font-bold mb-1" data-id="element-247">
                $69.000
              </p>
              <div className="flex items-baseline gap-2 justify-center" data-id="element-248">
                <span className="text-brand-gold glow-gold text-lg" data-id="element-249">✦</span>
                <span className="font-display text-5xl font-extrabold text-brand-gold glow-gold" data-id="element-250">
                  $27.990
                </span>
                <span className="text-xl font-bold text-brand-gold/70" data-id="element-251">
                  ARS
                </span>
                <span className="text-brand-gold glow-gold text-lg" data-id="element-252">✦</span>
              </div>
            </div>

            <motion.a href="https://www.impulsodigitalstore.com/cart/42985557327949:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-brand-gold text-brand-base font-extrabold text-base sm:text-lg py-4 px-6 rounded-xl shadow-lg hover:shadow-[0_10px_40px_rgba(212,168,67,0.6)] transition-all text-center inline-block uppercase tracking-wide" data-id="element-253">
              👑 QUIERO EL PACK COMPLETO
            </motion.a>
          </motion.div>
        </div>
      </div>
    </section>;
}